import { IChildrenActionPage, IComponentName } from './';

export enum AppSystem {
    OCS = 'ocs',
    BILLING = 'billing',
}

export type IRouterState = {
    appSystem?: AppSystem;
    forcedUpdate?: () => void;
    params?: IRouterParams;
    queryParams?: IRouterParams;
    routeName: IComponentName;
    title?: string;
};

export type IRouterParams = {
    [key: string]: string;
};

type IRightListType = 'isList' | 'isView' | 'isNew' | 'isEdit' | 'isDelete';

export type IRightList = IChildrenActionPage & {
    [id in IRightListType]?: boolean;
};

export type IGetChildrenPage = {
    editComponentIsRight?: boolean;
    editComponentLink: string;
    editComponentName: IComponentName;
    viewComponentIsRight?: boolean;
    viewComponentLink: string;
    viewComponentName: IComponentName;
};
